import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'bt-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})

export class UserComponent {

  constructor() { }

}
